<h1 *ngIf="isSubjectToCMP" class="page-title">Annual CMP Payment</h1>
<h1 *ngIf="!isSubjectToCMP" class="page-title">Annual Support Payment</h1>

<p *ngIf="isRenewalPending && isSubjectToCMP">We will begin accepting annual CMP payments for the next year in October.</p>
<p *ngIf="isRenewalPending && !isSubjectToCMP">Thank you for your support. We will begin accepting annual support payments for the next year in October.</p>

<p *ngIf="isIneligible">You are not eligible to pay at this time.</p>

<form *ngIf="!isRenewalPending && !isIneligible" [formGroup]="renewalForm" (ngSubmit)="onSubmit(renewalForm.value)">
    <p>It is the mission of the NBRC to protect and enhance patient lives by promoting excellence in respiratory care. 
        Part of being a professional is to recognize the value of your credentials and support the organization that stands behind them. 
        Participating in the annual program is another way excellence defines you as a credentialed respiratory care practitioner.</p>
  
  <span *ngIf="renewalInfo && renewalInfo.length>1">
    <p>You may submit payment for the following year(s). Please make your selection(s) below.</p>
  </span>
  <div class="renewal" style="margin-bottom: 10px;" *ngFor="let renewal of renewalInfo let i = index;">
    <div><p><span><input type="checkbox" name=pickRenwal (change)="pickRenewal(renewal, $event.target.checked)"> {{renewal.renewalYear}} Payment</span></p></div>
    <div *ngIf="askCharities(renewal.renewalYear) && enableCharity(renewal.renewalYear)">
      <div *ngIf="renewal.renewalYear<2022">CHOOSE ONE: Every Breath Counts Campaign allows you to be a part of making a collective
        difference by letting your credential help change the world. You may choose to have a portion of your annual
        credential maintenance fee go to one of three patient advocacy organizations. Every donation counts and when
        combined nationally, will make a powerful impact by improving lives through better breathing.
        <strong>There is no additional cost to you for selecting an option below, so we encourage you to CHOOSE ONE and help make a difference.</strong>
      </div>
      <div *ngIf="renewal.renewalYear>=2022 && renewal.renewalYear<2023">CHOOSE TO GIVE: Let your credentials be part of making a shared difference and support the respiratory care profession. 
        At no additional cost to you, the CHOOSE TO GIVE campaign will focus on the need to recruit and retain more respiratory therapists through educational scholarships,
         grants and awards for students and practitioners.  Support career advancement for current and future practitioners and inspire new leaders in the profession 
         by selecting ‘I choose to give’ below. 
      </div>

      <div *ngIf="renewal.renewalYear<2022"style="margin-left: 50px; margin-top: 10px">
        <span *ngFor="let charity of getRenewalYearCharity(renewal.renewalYear)" class="input-group-inLine"> 
          <div><input type="radio" name="charity" (click)="pickCharity(renewal.renewalYear, charity)">{{charity.description}} 
            <span *ngIf="charity.htmlLink" title={{charity.extendedDescription}}><a target="_blank" href={{charity.htmlLink}}>info</a></span>
          </div>
        </span>
      </div>

      <div *ngIf="renewal.renewalYear>=2022 && renewal.renewalYear<2023" style="margin-left: 50px; margin-top: 10px" class="input-group-inLine">
        <input type="checkbox" name="charity" (click)="chooseToParticipate(renewal.renewalYear, $event.target.checked)">I choose to give.
      </div>

    </div>
  </div>  


    <fieldset class="field-group">
    </fieldset>
    <input type="submit" class="button" value="Continue"/>
</form>
